import * as notification from '../../components/notifications';
import {getFormData, resetFormErrors, showFormErrors} from "../../utils/form";

let selectedJobId = null;
let provideReasonForm = null;
const jobsToSelectedReasonsMap = {};

const initPage = () => {
  const jobsList = $("#jobs-list-block");
  if (!jobsList.length) {
    return ;
  }

  provideReasonForm = $('#close-job-reason-form');

  provideReasonForm.find('input[name="reason"]').each(function () {
    $(this).on('change', function () {
      const otherReasonContainer = $('#reason-other-comment-container', provideReasonForm);
      otherReasonContainer.toggle(this.value === 'other');

      if (!jobsToSelectedReasonsMap[selectedJobId]) {
        jobsToSelectedReasonsMap[selectedJobId] = {};
      }

      jobsToSelectedReasonsMap[selectedJobId]['reason'] = this.value;
    });
  });

  //set listener for textarea to save the comment for each job
  provideReasonForm.find('#reason-other-comment').on('input', function () {
    jobsToSelectedReasonsMap[selectedJobId]['comment'] = $(this).val();
  });

  $(".btn-close-job", jobsList).click(function(){
    selectedJobId = $(this).data('jobId');
    resetFormErrors(provideReasonForm);
    setPreviouslySelectedValuesForCurrentJob();
    openModal();

    return false;
  });

  $("#modal-close-job .btn-modal-confirm").click(function(){
    closeSelectedJob();
  });
};

const openModal = () => {
  $('#modal-close-job').modal('show');
};

const setPreviouslySelectedValuesForCurrentJob = () => {
  //set all checkboxes to unchecked
  $('input[name="reason"]', provideReasonForm).prop('checked', false);

  const commentContainer = $('#reason-other-comment-container', provideReasonForm);
  const commentTextarea = $('#reason-other-comment', commentContainer);
  //hide comment textarea
  commentContainer.hide();

  //set comment to empty
  commentTextarea.val('');

  if (!jobsToSelectedReasonsMap[selectedJobId]) {
    return;
  }

  //set comment value for current job
  const commentValue =  jobsToSelectedReasonsMap[selectedJobId]['comment'];
  commentTextarea.val(commentValue);

  //set reason value for current job
  const reasonValue = jobsToSelectedReasonsMap[selectedJobId]['reason'];
  $(`input[type="radio"][value="${reasonValue}"]`, provideReasonForm).prop('checked', true);

  //show comment textarea if selected reason is "other"
  if (reasonValue === 'other') {
    commentContainer.show();
  }
}

const closeSelectedJob = async () => {
  const confirmBtn = $("#modal-close-job .btn-modal-confirm");

  confirmBtn.loading(true);

  const data = getFormData(provideReasonForm);
  data['job_id'] = selectedJobId;

  try {
    const response = await axios.post("/api/closed_job_reasons", data);
    notification.success(response.data.message);
    selectedJobId = null;

    setTimeout(function () {
      location.reload();
    }, 1000);
    $('#modal-close-job').modal('hide');
  } catch (e) {
    confirmBtn.loading(false);

    showFormErrors(provideReasonForm, e.response);
  }
};

$(initPage);
